import React, { useEffect } from "react";

import consumer from "@onsite_app/consumer";
import { useQueryClient } from "@tanstack/react-query";
import { produce } from "immer";
import { reduce } from "lodash";

import { Session } from "../Authentication";
import { billSplitKeys } from "../BillSplit/queries";
import { BillSplitReducer, parseChannelData } from "../BillSplit/reducer";
import { BillSplit } from "../BillSplit/schema";
import { SessionActions } from "./reducer";

export const useBillSplitChannel = (
  billSplit: BillSplit | null | undefined
) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (billSplit?.uuid == null) {
      return;
    }
    console.log("starting a actioncable");

    consumer.subscriptions.create(
      {
        channel: "BillSplitChannel",
        bill_split_id: billSplit.uuid,
      },
      {
        received: (data) => {
          console.log("received", data);
          try {
            const action = parseChannelData(data);
            console.log("action", action);
            queryClient.setQueryData(
              billSplitKeys.current(billSplit.customerTabId),
              (currentBillSplit: BillSplit) =>
                produce(currentBillSplit, (draft: BillSplit) => {
                  BillSplitReducer(draft, action);
                })
            );
          } catch (e) {
            console.error("Consumer Channel failed to pass action", data, e);
          }
        },
      }
    );
  }, [billSplit?.uuid]);
};
